var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.base))]),_c('span',{staticClass:"text-danger font-weight-bold"},[_vm._v(_vm._s(_vm.extraDigit))]),_c('span',[_vm._v(" g")])])
}
var staticRenderFns = []

export { render, staticRenderFns }